export type DateWindow = 'today' | 'yesterday' | 'thisMonth' | 'previousMonth';
export const DATE_WINDOWS: DateWindow[] = ['today', 'yesterday', 'thisMonth', 'previousMonth'];
export const DATE_WINDOW_STORAGE_KEY = 'webook-analytics-date-window';

export const readStoredDateWindow = (): DateWindow | null => {
  try {
    const raw = localStorage.getItem(DATE_WINDOW_STORAGE_KEY);
    return raw && (DATE_WINDOWS as string[]).includes(raw) ? (raw as DateWindow) : null;
  } catch {
    return null;
  }
};

export const persistDateWindow = (v: DateWindow | null) => {
  try {
    if (v) localStorage.setItem(DATE_WINDOW_STORAGE_KEY, v);
    else localStorage.removeItem(DATE_WINDOW_STORAGE_KEY);
  } catch {
    // ignore
  }
};
